var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.501 3.75a1 1 0 1 0-2 0v.592a7.73 7.73 0 0 0-6.659 6.659H4.25a1 1 0 1 0 0 2h.592a7.73 7.73 0 0 0 6.66 6.659v.592a1 1 0 1 0 2 0v-.592A7.73 7.73 0 0 0 20.16 13h.592a1 1 0 1 0 0-2h-.592A7.73 7.73 0 0 0 13.5 4.343zM17.696 11h.44a5.73 5.73 0 0 0-4.635-4.635v.44a1 1 0 1 1-2 0v-.44a5.73 5.73 0 0 0-4.636 4.636h.44a1 1 0 1 1 0 2h-.44a5.73 5.73 0 0 0 4.636 4.636v-.441a1 1 0 1 1 2 0v.44a5.73 5.73 0 0 0 4.636-4.635h-.441a1 1 0 1 1 0-2m-6.64 1a1.445 1.445 0 1 1 2.89 0 1.445 1.445 0 0 1-2.89 0m1.445-3.444a3.445 3.445 0 1 0 0 6.89 3.445 3.445 0 0 0 0-6.89",
    clipRule: "evenodd"
  })));
};
export default SvgLocation;